
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Divider, VStack } from '@chakra-ui/react';
import { GetStaticProps } from 'next';
import useTranslation from 'next-translate/useTranslation';
import HeadModule from '../../components/Modules/HeadModule';
import ServiceHeader from '../../components/Modules/ServiceHeader';
import ServiceList from '../../components/Modules/ServiceList';
import ServiceGroupButtons from '../../components/ServiceGroup/ServiceGroupButtons';
import ServiceGroupPlaceholder from '../../components/ServiceGroup/ServiceGroupPlaceholder';
import { getFourRandomSkills, REDACTION_SKILLS } from '../../constants/skills';
const ServiceGroupRedactionPlaceholder = ({ otherServices }: any) => {
    const skillsGroup = REDACTION_SKILLS;
    const { t } = useTranslation();
    return (<>
      <HeadModule title='meta_title_service_group_redaction' description='meta_description_service_group_redaction'/>
      <VStack w='full' spacing={20}>
        <VStack spacing={10} w='full'>
          <ServiceHeader serviceGroup={skillsGroup}/>
          <ServiceGroupButtons serviceGroup={skillsGroup}/>
          <ServiceGroupPlaceholder placeholder='service_redaction_placeholder'/>
        </VStack>
        <Divider variant='separator2' w={64}/>
        <ServiceList title={t('common:our_other_products')} serviceGroups={JSON.parse(otherServices)}/>
      </VStack>
    </>);
};
const getStaticProps: GetStaticProps = async () => {
    const otherServices = getFourRandomSkills();
    return {
        props: {
            otherServices: JSON.stringify(otherServices),
        },
        revalidate: 900,
    };
};
// noinspection JSUnusedGlobalSymbols
export default ServiceGroupRedactionPlaceholder;

    async function __Next_Translate__getStaticProps__196fbffbbab__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/redaction/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196fbffbbab__ as getStaticProps }
  